import React, { useState, useRef, useEffect } from 'react';
import Footer from '../../../compontents/footer';
import LeaseModal from '../../../compontents/LeaseModal';
import BusinessModal from '../../../compontents/businessModal';
import QrcodeModal from '../../../compontents/QrcodeModal';
import ScrollNav from '../../../compontents/scrollNav';
import { Carousel, Popover } from 'antd';
import { cloneDeep } from 'lodash';
import axios from 'axios';
import './index.less'

const EnterPricePage = () => {

  const slideRef = useRef()

  const getOld = new Map([
    [1, '全新'],
    [2, '99新'],
    [3, '95新'],
    [4, '9成新'],
    [5, '8成新'],
    [6, '7成新'],
  ]);

  const submitForm = (data) => axios({
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'post',
    url: '/consumer-zhifubao/aliPay/product/querySitProductList',
    responseType: 'json',
    data
  })

  const getFun = (data) => axios({
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'get',
    url: '/consumer-zhifubao/aliPay/category/selectSiteCategoryList',
    responseType: 'json',
    data
  })

  const cateFun = () => {
    getFun().then(res => {
      console.log(res, 'res')
      setAllCateData(res.data.data)
    })
  }

  const onFinish = (values) => {
    submitForm({
      type: values
    }).then(res => {
      console.log("666", res)
      if (values == 1) {
        setProductData(res.data.data)
      } else if (values == 2) {
        setProductData2(res.data.data)
      } else if (values == 3) {
        setProductData3(res.data.data)
      } else if (values == 4) {
        setProductData4(res.data.data)
      } else if (values == 5) {
        setProductData5(res.data.data)
      } else if (values == 6) {
        setProductData6(res.data.data)
      }
      // if (res?.data?.code === 1) {
      //   handleCancel()
      //   message.success(res.data.msg);
      // } else {
      //   message.error(res.data.msg);
      // }
    });
  };

  useEffect(() => {
    console.log('查询商品')
    onFinish(1)
    cateFun()
    onFinish(2)
    onFinish(3)
    onFinish(4)
    onFinish(5)
    onFinish(6)
    getNews()
  }, [])

  useEffect(() => {
    const leftRef = document.getElementById('recommendProduct')
    const leftLength = leftRef.getBoundingClientRect().left
    setLeftInfo(leftLength - 56 - 24)
    console.log(leftLength, 'leftLength')
  }, [])

  const getNews = (category, pageSize) => axios({
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'GET',
    url: `/consumer-zhifubao/news/center?newsCategory=0&pageSize=10&pageNumber=1`,
    responseType: 'json',
  }).then((res) => {
    if (res?.data?.code === 1) {
      setNewsData(res.data.data.opeNews)
    }
  })


  window.addEventListener('resize', () => {
    const leftRef = document.getElementById('recommendProduct')
    const leftLength = leftRef.getBoundingClientRect().left
    setLeftInfo(leftLength - 56 - 24)
    console.log(leftLength, 'leftLength')
  })

  window.addEventListener('scroll', () => {
    const scrollRef = document.getElementById('recommendProduct')
    const scrollTop = scrollRef.getBoundingClientRect().top
    console.log(scrollTop, 'scrollTop')
    if (scrollTop <= 0) {
      setLeftTop(scrollTop * -1)
      setShowLeft(true)
      if (scrollTop * -1 >= 4000) {
        setBottomInfo(300)
      } else {
        setBottomInfo(0)
      }
    } else {
      setShowLeft(false)
    }
  })

  const leftIndex = 0
  // const [leftIndex, setLeftIndex] = useState(0)
  const [leftTop, setLeftTop] = useState(0)
  const [showLeft, setShowLeft] = useState(false);
  const [hoverId, setHoverId] = useState(999);
  // const [showFix, setShowFix] = useState(false)
  const [isShowLease, setIsShowLease] = useState(false);
  const [isModalShow, setIsModalShow] = useState(false);
  const [isShowQrcode, setIsShowQrcode] = useState(false);
  const [leftInfo, setLeftInfo] = useState(0)
  const [bottomInfo, setBottomInfo] = useState(0)
  const [productData, setProductData] = useState([])
  const [allCateData, setAllCateData] = useState([])
  const [hoverCateData, setHoverCateData] = useState([])
  const [productData2, setProductData2] = useState([])
  const [productData3, setProductData3] = useState([])
  const [productData4, setProductData4] = useState([])
  const [productData5, setProductData5] = useState([])
  const [productData6, setProductData6] = useState([])
  const [productCode, setProductCode] = useState(null)
  const [newsData, setNewsData] = useState([]);

  const catelist1 = [
    {
      title: '笔记本',
      icon: 'https://oss.huizustore.com/bb96e032faa1424a80b47a6552330d6c.png',
      hoverIcon: 'https://oss.huizustore.com/7ae25cf6564246909e08a68f530c94c7.png',
      right: 'https://oss.huizustore.com/c91ac1291eef40409c74d37f8f3093b5.png',
      hoverRight: 'https://oss.huizustore.com/361a288bd5024613bb6e72876234c7c9.png'
    },
    {
      title: '台式电脑',
      icon: 'https://oss.huizustore.com/02d3862b7a8f4b49b0f0a506c16fdafe.png',
      hoverIcon: 'https://oss.huizustore.com/e8f58c1fe3ea4b9e9f61d571d500733f.png',
      right: 'https://oss.huizustore.com/c91ac1291eef40409c74d37f8f3093b5.png',
      hoverRight: 'https://oss.huizustore.com/361a288bd5024613bb6e72876234c7c9.png'
    },
    {
      title: '手机',
      icon: 'https://oss.huizustore.com/0aa91087adae486bba444404a0724b41.png',
      hoverIcon: 'https://oss.huizustore.com/38baf111df8f4fd1a9b2868d9b6fd1d4.png',
      right: 'https://oss.huizustore.com/c91ac1291eef40409c74d37f8f3093b5.png',
      hoverRight: 'https://oss.huizustore.com/361a288bd5024613bb6e72876234c7c9.png'
    },
    {
      title: '平板',
      icon: 'https://oss.huizustore.com/24da387965e74163938b805611e636a2.png',
      hoverIcon: 'https://oss.huizustore.com/2b4d8cf99e6a49548814e94ceaab1bbf.png',
      right: 'https://oss.huizustore.com/c91ac1291eef40409c74d37f8f3093b5.png',
      hoverRight: 'https://oss.huizustore.com/361a288bd5024613bb6e72876234c7c9.png'
    },
    {
      title: '电玩游戏机',
      icon: 'https://oss.huizustore.com/fc41fe6225c44400947638f5f11969ba.png',
      hoverIcon: 'https://oss.huizustore.com/8f7559abdc2c4a4a95d006a312e0ab38.png',
      right: 'https://oss.huizustore.com/c91ac1291eef40409c74d37f8f3093b5.png',
      hoverRight: 'https://oss.huizustore.com/361a288bd5024613bb6e72876234c7c9.png'
    },
    {
      title: '直播设备',
      icon: 'https://oss.huizustore.com/9d458a2ebadf4b22811a7f45e4d1f5a8.png',
      hoverIcon: 'https://oss.huizustore.com/415768eaff9c4d1989eb6312631d8d95.png',
      right: 'https://oss.huizustore.com/c91ac1291eef40409c74d37f8f3093b5.png',
      hoverRight: 'https://oss.huizustore.com/361a288bd5024613bb6e72876234c7c9.png'
    },
    {
      title: '办公周边',
      icon: 'https://oss.huizustore.com/646e20c075c14e5fba6daaaab2218da3.png',
      hoverIcon: 'https://oss.huizustore.com/9a963e2f601c45a681a5bffbf02b6757.png',
      right: 'https://oss.huizustore.com/c91ac1291eef40409c74d37f8f3093b5.png',
      hoverRight: 'https://oss.huizustore.com/361a288bd5024613bb6e72876234c7c9.png'
    },
    {
      title: '健康/母婴',
      icon: 'https://oss.huizustore.com/28271282cac749eea9d47dee27433d15.png',
      hoverIcon: 'https://oss.huizustore.com/33fd8537edcc4c83a9a11875a94bd7aa.png',
      right: 'https://oss.huizustore.com/c91ac1291eef40409c74d37f8f3093b5.png',
      hoverRight: 'https://oss.huizustore.com/361a288bd5024613bb6e72876234c7c9.png'
    },
    {
      title: '生活电器',
      icon: 'https://oss.huizustore.com/cef468e85dd14f92a8ddbd19170cd558.png',
      hoverIcon: 'https://oss.huizustore.com/3d77909c7ea14667b3074f13809f6c54.png',
      right: 'https://oss.huizustore.com/c91ac1291eef40409c74d37f8f3093b5.png',
      hoverRight: 'https://oss.huizustore.com/361a288bd5024613bb6e72876234c7c9.png'
    },
  ]

  const productList = [
    {
      title: '行政办公',
      id: '行政办公',
      datalist: [
        {}, {}, {}, {}, {}, {}, {}, {}, {}, {},
      ]
    },
    {
      title: '打印设备',
      id: '打印设备',
      datalist: [
        {}, {}, {}, {}, {}, {}, {}, {}, {}, {},
      ]
    },
  ]

  const cateList2 = [
    {
      title: '一级字体1',
      datalist: [
        '二级字体1',
        '二级字体2',
        '二级字体3',
        '二级字体4',
        '二级字体1',
        '二级字体2',
        '二级字体3',
        '二级字体4',
      ]
    },
    {
      title: '一级字体12',
      datalist: [
        '二级字体1',
        '二级字体2',
        '二级字体3',
        '二级字体4',
      ]
    },
    {
      title: '一级字体132',
      datalist: [
        '二级字体1',
        '二级字体2',
        '二级字体3',
        '二级字体4',
      ]
    },
  ]

  const cateList3 = [
    '行政办公',
    '打印设备',
    '电商直播',
    '游戏电竞',
    '设计剪辑',
  ]

  const changePages = (num) => {
    window.location.href = `${window.location.origin}${window.location.pathname}?flag=${num}`
  }

  const scrollToView = (index) => {
    let anchorElement
    if (index == 998) {
      anchorElement = document.getElementById(`recommendProduct`);
      console.log(anchorElement, 'anchorElement1')
    } else {
      anchorElement = document.getElementById(`catelink${Number(index) + 1}`);
      console.log(anchorElement, 'anchorElement2')
    }

    if (anchorElement) {
      anchorElement.scrollIntoView({
        block: 'start',
        behavior: 'smooth',
      });
    }
  }

  const slideFun = () => {
    // console.log(slideRef,'slideRef')
    //就两张轮播图都下一张就好了 上一张 prev()
    slideRef.current.next()
  }


  const toTopFun = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  const toProductPage = (id) => {
    // changePages(8)
    window.location.href = `${window.location.origin}${window.location.pathname}?flag=${8}&categoryId=${id}`
  }

  const onMouseOverFun = (id) => {
    let allData = cloneDeep(allCateData)
    setHoverId(id);
    console.log(allData[id], '划入数据')
    setHoverCateData(allData[id].children)
  }

  const autoPop = (str, n = 10) => {
    let name = str.slice(0, n) + '...'
    let r = str
    if (str.length > n) {
      r = (
        <Popover
          // overlayClassName={'Popover'}
          style={{ wordBreak: 'break-all' }}
          placement="top"
          title={false}
          content={str}
          trigger="hover"
        >
          {name}
        </Popover>
      )
    }
    return r
  }

  return (
    <div style={{ background: '#F9F8F8' }} className="allPage" id='allpage' >
      <div className='fixLeft' >
      </div>
      <ScrollNav />
      <div className='EnterPricePage' >
        <div className='topBox' >
          {allCateData && (
            <div className='topBox_left' >
              {hoverCateData && hoverCateData.length > 0 && (
                <div className='topBox_center_fixBox'   >
                  {hoverCateData.map(item => (
                    <div className='topBox_center_fixBox_item' >
                      <div className='topBox_center_fixBox_item_title' >
                        {item.label}
                      </div>
                      <div className='topBox_center_fixBox_item_childBox' >
                        {item.children.map(_item => (
                          <div className='topBox_center_fixBox_item_childBox_child' onClick={() => toProductPage(_item.associationId)} >
                            {_item.label}
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              )}
              <div className='topBox_left_top'  >
                全部商品品类
              </div>
              {/* {allCateData} */}
              {allCateData.map((item, index) => (
                <div className='topBox_left_item' onMouseOver={() => onMouseOverFun(index)} onMouseLeave={() => setHoverId(999)} >
                  <div className='topBox_left_item_left' >
                    <div className='topBox_left_item_left_icon' style={{ backgroundImage: `url(${index === hoverId ? catelist1[index].hoverIcon : catelist1[index].icon})` }} ></div>
                    <div className='topBox_left_item_left_name' >
                      {item.label}
                    </div>
                  </div>
                  <div className='topBox_left_item_icon1' style={{ backgroundImage: `url(${index === hoverId ? catelist1[index].hoverRight : catelist1[index].right})` }} ></div>
                </div>
              ))}
            </div>
          )}

          <div className='topBox_center' >
            <Carousel dots={false} autoplay={true} autoplaySpeed={5000} ref={slideRef}  >
              {/* dots={{ className: 'swiper-dots' }} */}
              <div className='topBox_center_top' onClick={() => setIsShowLease(true)} >
                <div className='topBox_center_top_content' >
                  <div className='topBox_center_top_content_content1' >
                    <div className='topBox_center_top_content_content1_icon' ></div>
                    <div className='topBox_center_top_content_content1_name' >惠租星企租</div>
                  </div>
                  <div className='topBox_center_top_content_content2' >直播｜办公｜电竞 专属定制</div>
                  <div className='topBox_center_top_content_content3' >助力企业 1000+  覆盖城市100+</div>
                  <div className='topBox_center_top_content_content4' >申请入口</div>
                </div>
              </div>
              <div className='topBox_center_top1' onClick={() => setIsModalShow(true)} >

              </div>
            </Carousel>
            <div className='topBox_center_linkLeft' onClick={() => slideFun()} >

            </div>
            <div className='topBox_center_linkRight' onClick={() => slideFun()} >

            </div>
            <div className='topBox_center_bottom' >
              <div className='topBox_center_bottom_item' >
                <div className='topBox_center_bottom_item_icon1' >

                </div>
                <div className='topBox_center_bottom_item_content' >
                  <div className='topBox_center_bottom_item_content_top' >
                    免押租赁
                  </div>
                  <div className='topBox_center_bottom_item_content_bottom' >
                    0押金信用免押
                  </div>
                </div>
              </div>
              <div className='topBox_center_bottom_item' >
                <div className='topBox_center_bottom_item_icon2' >

                </div>
                <div className='topBox_center_bottom_item_content' >
                  <div className='topBox_center_bottom_item_content_top' >
                    全程无忧
                  </div>
                  <div className='topBox_center_bottom_item_content_bottom' >
                    设备故障 快速响应
                  </div>
                </div>
              </div>
              <div className='topBox_center_bottom_item' >
                <div className='topBox_center_bottom_item_icon3' >

                </div>
                <div className='topBox_center_bottom_item_content' >
                  <div className='topBox_center_bottom_item_content_top' >
                    专人安装
                  </div>
                  <div className='topBox_center_bottom_item_content_bottom' >
                    专业团队 省心省力
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='topBox_right' >
            <div className='topBox_right_content1' >
              <div className='topBox_right_content1_left' >
                <div className='topBox_right_content1_left_qrcode' ></div>
                <div className='topBox_right_content1_left_tip' >支付宝扫码</div>
              </div>
              <div className='topBox_right_content1_right' >
                <div className='topBox_right_content1_right_qrcode1' ></div>
                <div className='topBox_right_content1_right_tip' >微信扫码关注</div>
              </div>
            </div>
            <div className='topBox_right_content2' >
              <div className='topBox_right_content2_left' ></div>
              <div className='topBox_right_content2_right' >
                <div className='topBox_right_content2_right_top' >客服电话：0571—26881669</div>
                <div className='topBox_right_content2_right_bottom' >人工服务：9:30—18:00</div>
              </div>
            </div>
            <div className='topBox_right_content3' >
              <div className='topBox_right_content3_top' >
                <div className='topBox_right_content3_top_left' >平台动态</div>
                <div className='topBox_right_content3_top_right' onClick={() => changePages(6)} >
                  <div className='topBox_right_content3_top_right_btn'>查看更多 </div>
                  <div className='topBox_right_content3_top_right_icon'></div>
                </div>
              </div>
              {
                !!newsData.length && newsData.slice(0, 2).map(item => (
                  <div className='topBox_right_content3_center' onClick={() => window.open(item.url)} >
                    <div className='topBox_right_content3_center_left' >{item.title}</div>
                    <div className='topBox_right_content3_center_right' >{item.createTime.split(' ')[0].slice(5)}</div>
                  </div>
                ))
              }
            </div>
            <div className='topBox_right_content4' >
              <div className='topBox_right_content4_pic1' >

              </div>
              <div className='topBox_right_content4_content' >
                <div className='topBox_right_content4_content_top' >
                  <div className='topBox_right_content4_content_top_name' >商家入驻</div>
                  <div style={{ display: 'flex', cursor: 'pointer' }} >
                    <div className='topBox_right_content4_content_top_btn' onClick={() => setIsModalShow(true)} >去入驻</div>
                    <div className='topBox_right_content4_content_top_icon' ></div>
                  </div>
                </div>
                <div className='topBox_right_content4_content_tip' >
                  免费入驻，商机无限
                </div>
              </div>
            </div>
            <div className='topBox_right_content4' >
              <div className='topBox_right_content4_pic2' >

              </div>
              <div className='topBox_right_content4_content' >
                <div className='topBox_right_content4_content_top' >
                  <div className='topBox_right_content4_content_top_name' >企业定制</div>
                  <div style={{ display: 'flex', cursor: 'pointer' }} onClick={() => setIsShowLease(true)} >
                    <div className='topBox_right_content4_content_top_btn' >去定制</div>
                    <div className='topBox_right_content4_content_top_icon' ></div>
                  </div>
                </div>
                <div className='topBox_right_content4_content_tip' >
                  量身定制，企业专属方案
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='recommendProduct' id='recommendProduct' >
          <div className='recommendProduct_titleBox' id={`catelink${999}`}  >
            <div className='recommendProduct_titleBox_title' >推荐</div>
            <div style={{ display: 'flex', cursor: 'pointer' }} onClick={() => { setProductCode(null); setIsShowQrcode(true) }} >
              <div className='recommendProduct_titleBox_btn' >查看更多 </div>
              <div className='recommendProduct_titleBox_icon' > </div>
            </div>

          </div>
          {productData && productData.length > 0 && (
            <div className='recommendProduct_product'   >
              {showLeft && (
                <div className='recommendProduct_product_fixLeft' style={bottomInfo ? { left: leftInfo, bottom: bottomInfo, top: 0 } : { left: leftInfo, bottom: 0, top: 187 }}  >
                  <div className='recommendProduct_product_fixLeft_top' onClick={() => scrollToView(998)} >
                    推荐
                  </div>
                  {cateList3.map((item, index) => (
                    <div className='recommendProduct_product_fixLeft_item' onClick={() => scrollToView(index)} style={leftIndex - 1 === index ? { color: '#FF1A2E' } : {}} >
                      {item}
                    </div>
                  ))}
                  <div className='recommendProduct_product_fixLeft_bottom' onClick={() => toTopFun()} >
                    <div className='recommendProduct_product_fixLeft_bottom_pic' >

                    </div>
                    <div className='recommendProduct_product_fixLeft_bottom_name' >
                      顶部
                    </div>

                  </div>
                </div>
              )}
              <div className='recommendProduct_product_left' onClick={() => { setProductCode(productData[0].productInfo.productId); setIsShowQrcode(true) }} >

                {/* {console.log(productData, productData[0], productData[0].images, '主图')} */}
                <div className='recommendProduct_product_left_img' style={{ backgroundImage: `url(${productData[0].productInfo.images})` }} >
                  {productData[0].productInfo.unionProductStatus && (
                    <div className='recommendProduct_product_left_img_fixIcon' >

                    </div>
                  )}
                </div>
                <div className='recommendProduct_product_left_titleBox' >
                  <div className='recommendProduct_product_left_titleBox_oldNew' >{getOld.get(productData[0].productInfo.oldNewDegree)}</div>
                  <div className='recommendProduct_product_left_titleBox_title' >{productData[0].productInfo.productName ? autoPop(productData[0].productInfo.productName, 25) : '-'}</div>
                </div>
                <div className='recommendProduct_product_left_sku' >
                  {productData[0].productInfo.skuTitle}
                </div>
                <div className='recommendProduct_product_left_tagBox' >
                  {productData[0].productServiceLabs.map(item => (
                    <div className='recommendProduct_product_left_tagBox_tagItem' >
                      {item?.serviceLabName}
                    </div>
                  ))}
                </div>
                <div className='recommendProduct_product_left_bottom' >
                  <div className='recommendProduct_product_left_bottom_price' >
                    <span>¥</span>
                    <span className='recommendProduct_product_left_bottom_price_big' >{productData[0].productInfo.rent}</span>
                    <span>/天</span>
                  </div>
                  <div className='recommendProduct_product_left_bottom_address' >{productData[0].productInfo?.deliveryLicenseProvince} {productData[0].productInfo?.deliveryLicenseCity}</div>
                </div>
              </div>
              <div className='recommendProduct_product_other' >
                <div className='recommendProduct_product_other_item' onClick={() => { setProductCode(productData[1].productInfo.productId); setIsShowQrcode(true) }} >
                  <div className='recommendProduct_product_other_item_left' style={{ backgroundImage: `url(${productData[1].productInfo.images})` }} >
                    {productData[1].productInfo.unionProductStatus && (
                      <div className='recommendProduct_product_other_item_left_fixIcon' >

                      </div>
                    )}
                  </div>
                  <div className='recommendProduct_product_other_item_right' >
                    <div className='recommendProduct_product_other_item_right_titleBox' >
                      <div className='recommendProduct_product_other_item_right_titleBox_oldNew' >{getOld.get(productData[1].productInfo.oldNewDegree)}</div>
                      <div className='recommendProduct_product_other_item_right_titleBox_title' >{productData[1].productInfo.productName ? autoPop(productData[1].productInfo.productName, 25) : '-'}</div>
                    </div>
                    <div className='recommendProduct_product_other_item_right_sku' >
                      {productData[1].productInfo.skuTitle}
                    </div>
                    <div className='recommendProduct_product_other_item_right_tagBox' >
                      {productData[1].productServiceLabs.map(item => (
                        <div className='recommendProduct_product_other_item_right_tagBox_tagItem' >
                          {item?.serviceLabName}
                        </div>
                      ))}
                    </div>
                    <div className='recommendProduct_product_other_item_right_bottom' >
                      <div className='recommendProduct_product_other_item_right_bottom_price' >
                        <span>¥</span>
                        <span className='recommendProduct_product_other_item_right_bottom_price_big' >{productData[1].productInfo.rent}</span>
                        <span>/天</span>
                      </div>
                      <div className='recommendProduct_product_other_item_right_bottom_address' >{productData[1].productInfo?.deliveryLicenseProvince} {productData[1].productInfo?.deliveryLicenseCity}</div>
                    </div>
                  </div>
                </div>
                <div className='recommendProduct_product_other_item' style={{ marginTop: 16 }} onClick={() => { setProductCode(productData[2].productInfo.productId); setIsShowQrcode(true) }} >

                  <div className='recommendProduct_product_other_item_left' style={{ backgroundImage: `url(${productData[2].productInfo.images})` }} >
                    {productData[2].productInfo.unionProductStatus && (
                      <div className='recommendProduct_product_other_item_left_fixIcon' >

                      </div>
                    )}
                  </div>
                  <div className='recommendProduct_product_other_item_right' >
                    <div className='recommendProduct_product_other_item_right_titleBox' >
                      <div className='recommendProduct_product_other_item_right_titleBox_oldNew' >{getOld.get(productData[2].productInfo.oldNewDegree)}</div>
                      <div className='recommendProduct_product_other_item_right_titleBox_title' >{productData[2].productInfo.productName ? autoPop(productData[2].productInfo.productName, 25) : '-'}</div>
                    </div>
                    <div className='recommendProduct_product_other_item_right_sku' >
                      {productData[2].productInfo.skuTitle}
                    </div>
                    <div className='recommendProduct_product_other_item_right_tagBox' >
                      {productData[2].productServiceLabs.map(item => (
                        <div className='recommendProduct_product_other_item_right_tagBox_tagItem' >
                          {item?.serviceLabName}
                        </div>
                      ))}
                    </div>
                    <div className='recommendProduct_product_other_item_right_bottom' >
                      <div className='recommendProduct_product_other_item_right_bottom_price' >
                        <span>¥</span>
                        <span className='recommendProduct_product_other_item_right_bottom_price_big' >{productData[2].productInfo.rent}</span>
                        <span>/天</span>
                      </div>
                      <div className='recommendProduct_product_other_item_right_bottom_address' >{productData[2].productInfo?.deliveryLicenseProvince} {productData[2].productInfo?.deliveryLicenseCity}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='recommendProduct_product_other' >
                <div className='recommendProduct_product_other_item' onClick={() => { setProductCode(productData[3].productInfo.productId); setIsShowQrcode(true) }} >
                  <div className='recommendProduct_product_other_item_left' style={{ backgroundImage: `url(${productData[3].productInfo.images})` }} >
                    {productData[3].productInfo.unionProductStatus && (
                      <div className='recommendProduct_product_other_item_left_fixIcon' >

                      </div>
                    )}
                  </div>
                  <div className='recommendProduct_product_other_item_right' >
                    <div className='recommendProduct_product_other_item_right_titleBox' >
                      <div className='recommendProduct_product_other_item_right_titleBox_oldNew' >{getOld.get(productData[3].productInfo.oldNewDegree)}</div>
                      <div className='recommendProduct_product_other_item_right_titleBox_title' >{productData[3].productInfo.productName ? autoPop(productData[3].productInfo.productName, 25) : '-'}</div>
                    </div>
                    <div className='recommendProduct_product_other_item_right_sku' >
                      {productData[3].productInfo.skuTitle}
                    </div>
                    <div className='recommendProduct_product_other_item_right_tagBox' >
                      {productData[3].productServiceLabs.map(item => (
                        <div className='recommendProduct_product_other_item_right_tagBox_tagItem' >
                          {item?.serviceLabName}
                        </div>
                      ))}
                    </div>
                    <div className='recommendProduct_product_other_item_right_bottom' >
                      <div className='recommendProduct_product_other_item_right_bottom_price' >
                        <span>¥</span>
                        <span className='recommendProduct_product_other_item_right_bottom_price_big' >{productData[3].productInfo.rent}</span>
                        <span>/天</span>
                      </div>
                      <div className='recommendProduct_product_other_item_right_bottom_address' >{productData[3].productInfo?.deliveryLicenseProvince} {productData[3].productInfo?.deliveryLicenseCity}</div>
                    </div>
                  </div>
                </div>
                <div className='recommendProduct_product_other_item' style={{ marginTop: 16 }} onClick={() => { setProductCode(productData[4].productInfo.productId); setIsShowQrcode(true) }}>

                  <div className='recommendProduct_product_other_item_left' style={{ backgroundImage: `url(${productData[4].productInfo.images})` }} >
                    {productData[4].productInfo.unionProductStatus && (
                      <div className='recommendProduct_product_other_item_left_fixIcon' >

                      </div>
                    )}
                  </div>
                  <div className='recommendProduct_product_other_item_right' >
                    <div className='recommendProduct_product_other_item_right_titleBox' >
                      <div className='recommendProduct_product_other_item_right_titleBox_oldNew' >{getOld.get(productData[4].productInfo.oldNewDegree)}</div>
                      <div className='recommendProduct_product_other_item_right_titleBox_title' >{productData[4].productInfo.productName ? autoPop(productData[4].productInfo.productName, 25) : '-'}</div>
                    </div>
                    <div className='recommendProduct_product_other_item_right_sku' >
                      {productData[4].productInfo.skuTitle}
                    </div>
                    <div className='recommendProduct_product_other_item_right_tagBox' >
                      {productData[4].productServiceLabs.map(item => (
                        <div className='recommendProduct_product_other_item_right_tagBox_tagItem' >
                          {item?.serviceLabName}
                        </div>
                      ))}
                    </div>
                    <div className='recommendProduct_product_other_item_right_bottom' >
                      <div className='recommendProduct_product_other_item_right_bottom_price' >
                        <span>¥</span>
                        <span className='recommendProduct_product_other_item_right_bottom_price_big' >{productData[4].productInfo.rent}</span>
                        <span>/天</span>
                      </div>
                      <div className='recommendProduct_product_other_item_right_bottom_address' >{productData[4].productInfo?.deliveryLicenseProvince} {productData[4].productInfo?.deliveryLicenseCity}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

        </div>
        <div className='cateProduct' >
          {productData2 && productData2.length > 0 && (
            <div className='cateProduct_item' id={`catelink${1}`}  >
              <div className='cateProduct_item_titleBox' >
                <div className='cateProduct_item_titleBox_left' >
                  行政办公
                </div>
                <div style={{ display: 'flex', cursor: 'pointer' }} onClick={() => { setProductCode(null); setIsShowQrcode(true) }} >
                  <div className='cateProduct_item_titleBox_right' >
                    查看更多
                  </div>
                  <div className='cateProduct_item_titleBox_icon' >
                  </div>
                </div>

              </div>
              <div className='cateProduct_item_productBox' >
                {productData2.map((_item, index) => (
                  <div className='cateProduct_item_productBox_item' style={(index + 1) % 5 === 0 ? { marginRight: 0 } : {}} onClick={() => { setProductCode(_item.productInfo.productId); setIsShowQrcode(true) }} >

                    <div className='cateProduct_item_productBox_item_img' style={{ backgroundImage: `url(${_item.productInfo.images})` }} >
                      {_item?.productInfo?.unionProductStatus && (
                        <div className='cateProduct_item_productBox_item_img_fixIcon' >

                        </div>
                      )}
                    </div>
                    <div className='cateProduct_item_productBox_item_titleBox' >
                      <div className='cateProduct_item_productBox_item_titleBox_oldNew' >{getOld.get(_item.productInfo.oldNewDegree)}</div>
                      <div className='cateProduct_item_productBox_item_titleBox_title' >{_item.productInfo.productName ? autoPop(_item.productInfo.productName,25) : '-'}</div>
                    </div>
                    <div className='cateProduct_item_productBox_item_sku' >
                      {_item.productInfo.skuTitle}
                    </div>
                    <div className='cateProduct_item_productBox_item_tagBox' >
                      {_item.productServiceLabs.map(item => (
                        <div className='cateProduct_item_productBox_item_tagBox_tagItem' >
                          {item?.serviceLabName}
                        </div>
                      ))}

                    </div>
                    <div className='cateProduct_item_productBox_item_bottom' >
                      <div className='cateProduct_item_productBox_item_bottom_price' >
                        <span>¥</span>
                        <span className='cateProduct_item_productBox_item_bottom_price_big' >{_item.productInfo.rent}</span>
                        <span>/天</span>
                      </div>
                      <div className='cateProduct_item_productBox_item_bottom_address' >{_item.productInfo?.deliveryLicenseProvince} {_item.productInfo?.deliveryLicenseCity}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          {productData3 && productData3.length > 0 && (
            <div className='cateProduct_item' id={`catelink${2}`}  >
              <div className='cateProduct_item_titleBox' >
                <div className='cateProduct_item_titleBox_left' >
                  打印设备
                </div>
                <div style={{ display: 'flex', cursor: 'pointer' }} onClick={() => { setProductCode(null); setIsShowQrcode(true) }} >
                  <div className='cateProduct_item_titleBox_right' >
                    查看更多
                  </div>
                  <div className='cateProduct_item_titleBox_icon' >
                  </div>
                </div>

              </div>
              <div className='cateProduct_item_productBox' >
                {productData3.map((_item, index) => (
                  <div className='cateProduct_item_productBox_item' style={(index + 1) % 5 === 0 ? { marginRight: 0 } : {}} onClick={() => { setProductCode(_item.productInfo.productId); setIsShowQrcode(true) }} >

                    <div className='cateProduct_item_productBox_item_img' style={{ backgroundImage: `url(${_item.productInfo.images})` }} >
                      {_item?.productInfo?.unionProductStatus && (
                        <div className='cateProduct_item_productBox_item_img_fixIcon' >

                        </div>
                      )}
                    </div>
                    <div className='cateProduct_item_productBox_item_titleBox' >
                      <div className='cateProduct_item_productBox_item_titleBox_oldNew' >{getOld.get(_item.productInfo.oldNewDegree)}</div>
                      <div className='cateProduct_item_productBox_item_titleBox_title' >{_item.productInfo.productName ? autoPop(_item.productInfo.productName,25) : '-'}</div>
                    </div>
                    <div className='cateProduct_item_productBox_item_sku' >
                      {_item.productInfo.skuTitle}
                    </div>
                    <div className='cateProduct_item_productBox_item_tagBox' >
                      {_item.productServiceLabs.map(item => (
                        <div className='cateProduct_item_productBox_item_tagBox_tagItem' >
                          {item?.serviceLabName}
                        </div>
                      ))}

                    </div>
                    <div className='cateProduct_item_productBox_item_bottom' >
                      <div className='cateProduct_item_productBox_item_bottom_price' >
                        <span>¥</span>
                        <span className='cateProduct_item_productBox_item_bottom_price_big' >{_item.productInfo.rent}</span>
                        <span>/天</span>
                      </div>
                      <div className='cateProduct_item_productBox_item_bottom_address' >{_item.productInfo?.deliveryLicenseProvince} {_item.productInfo?.deliveryLicenseCity}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          {productData4 && productData4.length > 0 && (
            <div className='cateProduct_item' id={`catelink${3}`}  >
              <div className='cateProduct_item_titleBox' >
                <div className='cateProduct_item_titleBox_left' >
                  电商直播
                </div>
                <div style={{ display: 'flex', cursor: 'pointer' }} onClick={() => { setProductCode(null); setIsShowQrcode(true) }} >
                  <div className='cateProduct_item_titleBox_right' >
                    查看更多
                  </div>
                  <div className='cateProduct_item_titleBox_icon' >
                  </div>
                </div>

              </div>
              <div className='cateProduct_item_productBox' >
                {productData4.map((_item, index) => (
                  <div className='cateProduct_item_productBox_item' style={(index + 1) % 5 === 0 ? { marginRight: 0 } : {}} onClick={() => { setProductCode(_item.productInfo.productId); setIsShowQrcode(true) }} >

                    <div className='cateProduct_item_productBox_item_img' style={{ backgroundImage: `url(${_item.productInfo.images})` }} >
                      {_item?.productInfo?.unionProductStatus && (
                        <div className='cateProduct_item_productBox_item_img_fixIcon' >

                        </div>
                      )}
                    </div>
                    <div className='cateProduct_item_productBox_item_titleBox' >
                      <div className='cateProduct_item_productBox_item_titleBox_oldNew' >{getOld.get(_item.productInfo.oldNewDegree)}</div>
                      <div className='cateProduct_item_productBox_item_titleBox_title' >{_item.productInfo.productName ? autoPop(_item.productInfo.productName,25) : '-'}</div>
                    </div>
                    <div className='cateProduct_item_productBox_item_sku' >
                      {_item.productInfo.skuTitle}
                    </div>
                    <div className='cateProduct_item_productBox_item_tagBox' >
                      {_item.productServiceLabs.map(item => (
                        <div className='cateProduct_item_productBox_item_tagBox_tagItem' >
                          {item?.serviceLabName}
                        </div>
                      ))}

                    </div>
                    <div className='cateProduct_item_productBox_item_bottom' >
                      <div className='cateProduct_item_productBox_item_bottom_price' >
                        <span>¥</span>
                        <span className='cateProduct_item_productBox_item_bottom_price_big' >{_item.productInfo.rent}</span>
                        <span>/天</span>
                      </div>
                      <div className='cateProduct_item_productBox_item_bottom_address' >{_item.productInfo?.deliveryLicenseProvince} {_item.productInfo?.deliveryLicenseCity}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          {productData5 && productData5.length > 0 && (
            <div className='cateProduct_item' id={`catelink${4}`}  >
              <div className='cateProduct_item_titleBox' >
                <div className='cateProduct_item_titleBox_left' >
                  游戏电竞
                </div>
                <div style={{ display: 'flex', cursor: 'pointer' }} onClick={() => { setProductCode(null); setIsShowQrcode(true) }} >
                  <div className='cateProduct_item_titleBox_right' >
                    查看更多
                  </div>
                  <div className='cateProduct_item_titleBox_icon' >
                  </div>
                </div>

              </div>
              <div className='cateProduct_item_productBox' >
                {productData5.map((_item, index) => (
                  <div className='cateProduct_item_productBox_item' style={(index + 1) % 5 === 0 ? { marginRight: 0 } : {}} onClick={() => { setProductCode(_item.productInfo.productId); setIsShowQrcode(true) }} >
                    <div className='cateProduct_item_productBox_item_img' style={{ backgroundImage: `url(${_item.productInfo.images})` }} >
                      {_item?.productInfo?.unionProductStatus && (
                        <div className='cateProduct_item_productBox_item_img_fixIcon' >

                        </div>
                      )}
                    </div>
                    <div className='cateProduct_item_productBox_item_titleBox' >
                      <div className='cateProduct_item_productBox_item_titleBox_oldNew' >{getOld.get(_item.productInfo.oldNewDegree)}</div>
                      <div className='cateProduct_item_productBox_item_titleBox_title' >{_item.productInfo.productName ? autoPop(_item.productInfo.productName,25) : '-'}</div>
                    </div>
                    <div className='cateProduct_item_productBox_item_sku' >
                      {_item.productInfo.skuTitle}
                    </div>
                    <div className='cateProduct_item_productBox_item_tagBox' >
                      {_item.productServiceLabs.map(item => (
                        <div className='cateProduct_item_productBox_item_tagBox_tagItem' >
                          {item?.serviceLabName}
                        </div>
                      ))}

                    </div>
                    <div className='cateProduct_item_productBox_item_bottom' >
                      <div className='cateProduct_item_productBox_item_bottom_price' >
                        <span>¥</span>
                        <span className='cateProduct_item_productBox_item_bottom_price_big' >{_item.productInfo.rent}</span>
                        <span>/天</span>
                      </div>
                      <div className='cateProduct_item_productBox_item_bottom_address' >{_item.productInfo?.deliveryLicenseProvince} {_item.productInfo?.deliveryLicenseCity}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          {productData6 && productData6.length > 0 && (
            <div className='cateProduct_item' id={`catelink${5}`}  >
              <div className='cateProduct_item_titleBox' >
                <div className='cateProduct_item_titleBox_left' >
                  设计剪辑
                </div>
                <div style={{ display: 'flex', cursor: 'pointer' }} onClick={() => { setProductCode(null); setIsShowQrcode(true) }} >
                  <div className='cateProduct_item_titleBox_right' >
                    查看更多
                  </div>
                  <div className='cateProduct_item_titleBox_icon' >
                  </div>
                </div>

              </div>
              <div className='cateProduct_item_productBox' >
                {productData6.map((_item, index) => (
                  <div className='cateProduct_item_productBox_item' style={(index + 1) % 5 === 0 ? { marginRight: 0 } : {}} onClick={() => { setProductCode(_item.productInfo.productId); setIsShowQrcode(true) }} >

                    <div className='cateProduct_item_productBox_item_img' style={{ backgroundImage: `url(${_item.productInfo.images})` }} >
                      {_item?.productInfo?.unionProductStatus && (
                        <div className='cateProduct_item_productBox_item_img_fixIcon' >

                        </div>
                      )}
                    </div>
                    <div className='cateProduct_item_productBox_item_titleBox' >
                      <div className='cateProduct_item_productBox_item_titleBox_oldNew' >{getOld.get(_item.productInfo.oldNewDegree)}</div>
                      <div className='cateProduct_item_productBox_item_titleBox_title' >{_item.productInfo.productName ? autoPop(_item.productInfo.productName,25) : '-'}</div>
                    </div>
                    <div className='cateProduct_item_productBox_item_sku' >
                      {_item.productInfo.skuTitle}
                    </div>
                    <div className='cateProduct_item_productBox_item_tagBox' >
                      {_item.productServiceLabs.map(item => (
                        <div className='cateProduct_item_productBox_item_tagBox_tagItem' >
                          {item?.serviceLabName}
                        </div>
                      ))}

                    </div>
                    <div className='cateProduct_item_productBox_item_bottom' >
                      <div className='cateProduct_item_productBox_item_bottom_price' >
                        <span>¥</span>
                        <span className='cateProduct_item_productBox_item_bottom_price_big' >{_item.productInfo.rent}</span>
                        <span>/天</span>
                      </div>
                      <div className='cateProduct_item_productBox_item_bottom_address' >{_item.productInfo?.deliveryLicenseProvince} {_item.productInfo?.deliveryLicenseCity}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

        </div>

      </div>
      <Footer />
      {isShowLease && (
        <LeaseModal
          isShowLease={isShowLease}
          canceLease={() => setIsShowLease(false)}
        />
      )}
      {isModalShow && (
        <BusinessModal visible={isModalShow} handleCancel={() => setIsModalShow(false)} />
      )}
      {isShowQrcode && (
        <QrcodeModal
          visible={isShowQrcode}
          handleCancel={() => setIsShowQrcode(false)}
          productId={productCode}
        />
      )}
    </div>
  )
}

export default EnterPricePage;